module.exports = __webpack_public_path__ + "img/selected2-min.5f34da2f.png";